import React from 'react';
import { Navigate } from 'react-router-dom';

// Old Treatment component now redirects to the unified Tratamentos page
export function Treatment() {
  return <Navigate to="/tratamentos" replace />;
}
